import React from 'react'
import { Placeholder } from 'react-bootstrap';

import './styles.css'

// define placeholder small card 
const SmallCardPlaceholder = () => {

    return (
        <Placeholder as="p" animation="wave"className="placeholder-small-card-container">
            <Placeholder xs={12} className="placeholder-small-card-title" />
            <Placeholder xs={12} className="placeholder-small-card-img" />
        </Placeholder>
    );
}

export default SmallCardPlaceholder;